export default "__VITE_ASSET__aA$57Q5U__"